import { Swiper, SwiperOptions } from 'swiper'
import { DOM, IOO, O, pipe } from '@packages/prelude'

export const create = (selector: string, options: SwiperOptions): O.Option<Swiper> =>
  pipe(
    IOO.of({ document }),
    IOO.chain(({ document }) => pipe(document, DOM.querySelector(`#${selector}`)) as IOO.IOOption<HTMLElement>),
    IOO.map(element => new Swiper(element, options))
  )()
